// extracted by LIB_CSS_EXTRACT_LOADER
import "./resizable_module.css"
export default {"group":"group-Z8B1di","handle":"handle-Vo0EtS","handleGrip":"handleGrip-KiXxXo","handleGripIcon":"handleGripIcon-fRBOU2"};